// React Query cache keys

export const queryKeys = {
  auth: {
    currentAccount: 'currentAccount',
  },
  invitations: {
    all: ['invitations'],
    detail: (id, token, authEmail) => [
      'invitations',
      'detail',
      id,
      token ?? '',
      authEmail ?? '',
    ],
  },
  users: {
    all: ['users'],
    detail: (userId) => ['users', 'detail', userId],
  },
  teamTimeTracking: {
    report: (teamId, startDate, endDate, timezone) => [
      'teamTimeTracking',
      'report',
      teamId,
      startDate,
      endDate,
      timezone,
    ],
  },
  teamMemberDetails: {
    detail: (teamId) => ['teamMemberDetails', teamId],
  },
  memberTimezone: {
    forUser: (userId) => ['memberTimezone', userId],
  },
  employeeList: {
    /** Per-user enrichment (membersDatabase + license) for Employee List details / edit */
    extendedDetails: (userId) => ['employeeList', 'extendedDetails', userId],
  },
  teamList: {
    teamsForCompany: (userUID, companyId) => [
      'teamList',
      'teamsForCompany',
      userUID ?? '',
      companyId ?? '',
    ],
  },
  applicationInfo: {
    mapping: ['applicationInfo', 'mapping'],
  },
  appDownloadUrls: {
    mapping: ['appDownloadUrls', 'mapping'],
  },
  productivityApps: {
    company: (companyId) => ['productivityApps', 'company', companyId ?? ''],
    team: (teamId) => ['productivityApps', 'team', teamId ?? ''],
  },
  holidays: {
    teamOverrides: (teamId, year) => [
      'holidays',
      'teamOverrides',
      teamId ?? '',
      year ?? '',
    ],
  },
  urlTracking: {
    sessionActivities: (teamId, userId, sessionId) => [
      'urlTracking',
      'sessionActivities',
      teamId ?? '',
      userId ?? '',
      sessionId ?? '',
    ],
  },
};
